"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _events = _interopRequireDefault(require("events"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Channel = /*#__PURE__*/function () {
  function Channel(topic, provider) {
    _classCallCheck(this, Channel);

    this.topic = topic;
    this.provider = provider;
    this.isListening = false;
    this.eventEmitter = new _events["default"]();
  }

  _createClass(Channel, [{
    key: "run",
    value: function run() {
      if (this.isListening === false) {
        this.provider.on(this.topic, this.bridge.bind(this));
        this.isListening = true;
      }
    }
  }, {
    key: "on",
    value: function on(callback) {
      this.run();
      this.eventEmitter.on("message", callback);
    }
  }, {
    key: "once",
    value: function once(callback) {
      this.run();
      this.eventEmitter.once("message", callback);
    }
  }, {
    key: "send",
    value: function send(message) {
      return this.provider.send(this.topic, message);
    }
    /**
     * При получении сообщения от провайдера, создает событие для мессенджер
     *
     * @method bridge
     *
     * @param {String} message
     */

  }, {
    key: "bridge",
    value: function bridge(message) {
      this.eventEmitter.emit("message", this.provider.messageDecode(message));
    }
  }, {
    key: "off",
    value: function off(callback) {
      this.eventEmitter.removeListener("message", callback);
    }
  }, {
    key: "stop",
    value: function stop() {
      this.eventEmitter.removeAllListeners();
      this.provider.off(this.topic, this.bridge.bind(this));
      this.isListening = false;
    }
  }]);

  return Channel;
}();

exports["default"] = Channel;